<app-markdown [source]="part().text" />
@if (!part().complete) {
  <span class="inline-block w-2 h-4 bg-foreground-primary-100 rounded-sm animate-pulse ml-0.5"></span>
}
